/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isApplicableForLoanType, isStrEmptyOrNull } from '../../common/UtilityFunctions';
import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import { useMemo } from 'react';
import LoanInformationStyles from '../../css/LoanInformation.module.css';
import dateInputRow from './DateInputRow';
import SelectDropdown from './Dropdown';
import DDSCodeList from './List';

const gnmaCol = () => {
  const { LDCInfo, LDCUIStatuses, LDCFunctions, gnmaColToggled } = useLDCContext();
  const { isEditable } = LDCUIStatuses;
  const { handleLDCChange, editDDSvars, checkReportingDate, checkEstimatedForbearanceDates } = LDCFunctions;

  const {
    EstimatedForbearanceStartDate,
    EstimatedForbearanceEndDate,
    InvestorDDRDate,
    investorDDSReportingDate,
    investorDDSEventDate,
  } = LDCInfo.dates;

  const { investorDDROptions, InvestorDDSCodeOptions } = LDCInfo.QIDOptions;

  const { investorDdrReason, investorLoanType, investorDDSCode, investorDDSCodesListForLoan } = LDCInfo;

  const filteredInvestorDDSCodeOptions = useMemo(
    () => InvestorDDSCodeOptions.filter((element) => isApplicableForLoanType(investorLoanType, element)),
    [investorLoanType, InvestorDDSCodeOptions],
  );
  return (
    gnmaColToggled && (
      <table className={LoanInformationStyles.loanInfoTableSection}>
        <tbody>
          <tr>
            <th>GNMA Reporting</th>
          </tr>

          <SelectDropdown
            name={'investorDDSCode'}
            value={investorDDSCode}
            options={filteredInvestorDDSCodeOptions}
            label={'Add Investor DDS Code'}
            func={(e) => {
              handleLDCChange('edit', 'investorDDSCode', e.target.value);
              editDDSvars(true);
            }}
          ></SelectDropdown>

          {!isStrEmptyOrNull(investorDDSCode) &&
            dateInputRow(
              'Reporting Date',
              investorDDSReportingDate,
              'dates.investorDDSReportingDate',
              !isEditable,
              (e) => {
                checkReportingDate(e, true);
              },
            )}

          {!isStrEmptyOrNull(investorDDSCode) &&
            dateInputRow('Investor DDS Date', investorDDSEventDate, 'dates.investorDDSEventDate', !isEditable)}

          {investorDDSCodesListForLoan.length !== 0 && (
            <DDSCodeList list={investorDDSCodesListForLoan} investor={true}></DDSCodeList>
          )}

          <SelectDropdown
            name={'investorDdrReason'}
            value={investorDdrReason}
            options={investorDDROptions}
            label={'Investor DDR Reason'}
          ></SelectDropdown>

          {dateInputRow('Investor DDR Date', InvestorDDRDate, 'dates.InvestorDDRDate', !isEditable)}

          {dateInputRow(
            'Estimated Forbearance Start Date',
            EstimatedForbearanceStartDate,
            'dates.EstimatedForbearanceStartDate',
            !isEditable,
            checkEstimatedForbearanceDates,
          )}

          {dateInputRow(
            'Estimated Forbearance End Date',
            EstimatedForbearanceEndDate,
            'dates.EstimatedForbearanceEndDate',
            !isEditable,
            checkEstimatedForbearanceDates,
          )}
        </tbody>
      </table>
    )
  );
};

export default gnmaCol;
